import { CartLinesUpdateEvent } from '@shopify/events';
if (!customElements.get('ch-cable-builder')) {
  customElements.define('ch-cable-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.q = selector => this.querySelector(selector);
      this.config = JSON.parse(this.q('[data-builder-config]').textContent);
      this.q('[data-connector-options]').hidden = false;
      this.q('[data-connection]').hidden = true;
      this.photos = new Map();
      this.context = this.q('canvas').getContext('2d', { willReadFrequently: true });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-connector-pick]')) this.q('[data-connection]').value = event.target.value;
        if (event.target.matches('[data-usb-upgrade]')) this.q('[data-connection]').value = event.target.checked ? 'USB4' : 'CC';
        if (event.target.matches('input[type=radio],select,[data-usb-upgrade]')) this.render();
      });
      this.q('[data-help-apply]').addEventListener('click', () => {
        const device=this.q('[data-help-device]').value, port=this.q('[data-help-port]:checked')?.value;
        const result=this.q('[data-help-result]');
        if (!device || !port) { result.textContent='Choose your device and a port above.'; return; }
        this.q('[data-connection]').value=device==='L'?(port==='C'?'CL':'AL'):(port==='C'?'CC':'CA');
        this.render();
        result.textContent='Selected: '+this.q('[data-connection]').selectedOptions[0].textContent;
      });
      this.q('[data-reset]').addEventListener('click', () => {
        this.q('[data-colour]').checked = true;
        this.q('input[value="1m"]').checked = true;
        this.q('input[value="Straight"]').checked = true;
        this.q('[data-connection]').value = 'CC';
        this.wasCoiled = false;
        this.render();
      });
      const params = new URLSearchParams(location.search);
      for (const [key,selector] of [['colour','[data-colour]'],['length','input[name="contact[Cable length]"]']]) {
        const value=params.get(key);
        const input=[...this.querySelectorAll(selector)].find(el=>el.value===value);
        if(input) input.checked=true;
      }
      const connection=params.get('connection');
      if([...this.q('[data-connection]').options].some(o=>o.value===connection)) this.q('[data-connection]').value=connection;
      this.q('[data-mto-form]').addEventListener('submit', event => this.add(event));
      this.render();
      if (connection === 'USB4') this.q('[data-usb-stock]').scrollIntoView({block:'center'});
    }
    async add(event) {
      event.preventDefault();
      if (this.busy) return;
      const v=this.variant, qty=Number(this.q('[data-mto-quantity]').value), error=this.q('[data-mto-error]'), button=this.q('[data-mto-add]');
      error.textContent='';
      if(!v?.available || !Number.isInteger(qty) || qty<1 || qty>99){error.textContent=this.config.unavailable;return;}
      this.busy=true;button.disabled=true;button.textContent=this.config.adding;
      let deferred, added=false;
      try {
        const sections=[...new Set([...document.querySelectorAll('cart-items-component')].map(el=>el.dataset.sectionId).filter(Boolean))];
        deferred=CartLinesUpdateEvent.createPromise();deferred.promise.catch(()=>{});
        this.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:[{merchandiseId:String(v.id),quantity:qty}],promise:deferred.promise}));
        const response=await fetch(this.config.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:qty,properties:{Fulfilment:'Made to order',Dispatch:'Ships in approximately 2 weeks'}}],sections,sections_url:location.pathname+location.search})});
        const data=await response.json();
        if(!response.ok || data.status)throw new Error(data.description || this.config.errorAdd);
        added=true;
        const cartResponse=await fetch(this.config.root+'cart.js',{headers:{Accept:'application/json'}});
        if(!cartResponse.ok)throw new Error(this.config.errorAdd);
        const cart=await cartResponse.json();
        deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'product-form-component',sourceId:this.id,itemCount:qty,productId:String(this.config.productId),sections:data.sections,didError:false}});
        document.querySelectorAll('.ch-cart span').forEach(el=>el.textContent='('+cart.item_count+')');
        this.q('[data-mto-added]').hidden=false;
        if(!document.getElementById('cart-drawer'))location.assign(this.config.root+'cart');
      } catch(e) { deferred?.reject(e);error.textContent=e.message || this.config.errorAdd; if(added)this.q('[data-mto-added]').hidden=false; }
      finally {this.busy=false;button.disabled=!this.variant?.available;button.textContent=this.config.copy+' ↗';}
    }
    motion() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
    state() {
      const colour = this.q('[data-colour]:checked');
      const connection = this.q('[data-connection]');
      return { colour: colour.value, hex: colour.dataset.colour, length: this.q('input[name="contact[Cable length]"]:checked').value, style: this.q('input[name="contact[Cable style]"]').value, connection: connection.value, connectionName: connection.selectedOptions[0].textContent };
    }
    updateSummary() {
      const s = this.state();
      const text = [s.colour, s.length, s.connectionName].join(' · ');
      this.q('[data-mto-selection]').textContent = text;
      return s;
    }
    render() {
      const usb = this.q('[data-connection]').value === 'USB4';
      if (usb) { this.q('[data-colour][value="Jet Black"]').checked = true; this.q('input[value="1m"]').checked=true; this.q('input[value="Straight"]').checked=true; this.wasCoiled=false; }
      this.querySelectorAll('[data-colour]').forEach(el=>el.disabled=usb && el.value!=='Jet Black');
      this.querySelectorAll('input[name="contact[Cable style]"]').forEach(el=>el.disabled=usb && el.value!=='Straight');
      this.q('[data-usb-stock]').hidden=!usb;
      this.q('.ch-builder-next').hidden=usb;
      const sticker=this.q('[data-builder-sticker]');
      if (!this.originalSticker) this.originalSticker=sticker.textContent;
      sticker.textContent=usb?'USB 4.0':this.originalSticker;
      for (const selector of ['[data-custom-spec-note]','[data-custom-dispatch]']) { const el=this.q(selector); if(!el.dataset.original)el.dataset.original=el.textContent; el.textContent=usb?(selector.includes('dispatch')?'The black 1m USB4 cable ships from stock with same-day dispatch while available.':'Up to 8K display and 240W charging with compatible equipment.'):el.dataset.original; }
      for (const [selector,copy] of [['[data-builder-material]','Silicone · silver aluminium connectors']]) { const el=this.q(selector); if(!el.dataset.original)el.dataset.original=el.textContent; el.textContent=usb?copy:el.dataset.original; }
      const isCoiled = this.q('input[name="contact[Cable style]"]').value === 'Coiled';
      const lengths = [...this.querySelectorAll('input[name="contact[Cable length]"]')];
      if (isCoiled && !this.wasCoiled) this.straightLength = lengths.find(el => el.checked)?.value;
      if (isCoiled) this.q('input[value="1.5m"]').checked = true;
      else if (this.wasCoiled) { const previous = lengths.find(el => el.value === this.straightLength); if (previous) previous.checked = true; }
      lengths.forEach(el => { el.disabled = usb ? el.value !== '1m' : isCoiled && el.value !== '1.5m'; });
      this.wasCoiled = isCoiled;
      const s = this.updateSummary();
      this.variant = this.config.variants.find(v => v.options[0] === s.colour && v.options[1] === s.length && v.options[2] === s.connectionName);
      this.q('[data-mto-price]').textContent = this.variant ? new Intl.NumberFormat('en-AU',{style:'currency',currency:this.config.currency}).format(this.variant.price / 100) : this.config.unavailable;
      this.q('[data-mto-add]').disabled = this.busy || !this.variant?.available;
      this.q('[data-mto-added]').hidden = true;
      this.q('[data-usb-branch]').hidden = !['CC','USB4'].includes(s.connection) || s.length !== '1m';
      this.q('[data-usb-upgrade]').checked = usb;
      this.q('.ch-usb-hint').textContent = usb ? '8K Display Compatible / USB 4.0 / Up to 240W' : 'Charging & syncing';
      this.querySelectorAll('[data-connector-pick]').forEach(el => { el.checked = el.value === s.connection || (usb && el.value === 'CC'); });
      this.q('[data-detail-selection]').textContent = [s.length, s.connectionName].join(' · ');
      this.q('[data-builder-specs]').innerHTML = this.config.profiles[s.connection];
      this.q('[data-colour-name]').textContent = s.colour;
      this.q('[data-selected-colour]').textContent = s.colour;
      this.q('[data-preview-meta]').textContent = [s.length, s.connectionName].join(' · ');
      const coiled = s.style === 'Coiled';
      const reference = this.q('[data-reference-photo]');
      const photoUrl = usb ? this.config.usbPhoto : this.q('[data-colour]:checked').dataset.photo;
      reference.hidden = coiled || !photoUrl;
      if (photoUrl) reference.src = photoUrl;
      this.q('canvas').hidden = coiled;
      this.q('[data-coil]').toggleAttribute('hidden', !coiled);
      this.q('[data-coil-note]').hidden = !coiled;
      this.q('[data-image-note]').hidden = coiled || usb;
      if (coiled) {
        this.q('[data-loading]').hidden = true;
        this.q('[data-coil]').style.setProperty('--wire', s.hex);
        let path = 'M165 300';
        for (let i = 0; i < 9; i++) { const x = 165 + i * 32; path += ` C${x-12} 205 ${x+44} 205 ${x+32} 300 C${x+20} 395 ${x-12} 395 ${x} 300`; }
        path += ' L455 300';
        this.q('[data-coil-loops]').setAttribute('d', path);
        const ends = {CC:['USB-C','USB-C'],USB4:['USB-C','USB-C'],CA:['USB-C','USB-A'],CL:['USB-C','Lightning'],AL:['USB-A','Lightning']}[s.connection];
        this.q('[data-end-a]').textContent = ends[0]; this.q('[data-end-b]').textContent = ends[1];
        this.q('[data-coil]').setAttribute('aria-label', [s.colour,s.style,s.connectionName].join(', '));
      } else if (photoUrl) { this.q('canvas').hidden = true; this.q('[data-loading]').hidden = true; } else this.drawPhoto(s);
    }
    drawPhoto(s) {
      const index = ['50cm','1m','1.5m','2m','3m'].indexOf(s.length);
      let photo = this.photos.get(index);
      if (!photo) {
        photo = new Image();
        photo.crossOrigin = 'anonymous';
        this.photos.set(index, photo);
        photo.onload = () => this.render();
        photo.onerror = () => { photo.failed = true; this.render(); };
        photo.src = this.config.photos[index];
      }
      const canvas = this.q('canvas'), loading = this.q('[data-loading]');
      canvas.setAttribute('aria-label', [s.colour,s.connectionName,s.length].join(', '));
      if (!photo.complete || !photo.naturalWidth) {
        this.context.clearRect(0,0,620,620);
        loading.hidden = false;
        if (photo.failed) loading.textContent = this.config.error;
        return;
      }
      loading.hidden = true;
      try {
        const [column,row] = {CL:[0,0],CC:[1,0],USB4:[1,0],CA:[0,1],AL:[1,1]}[s.connection];
        const cellWidth = photo.width/2;
        const cropTop = index===4 ? (row===0?0:photo.height*610/1254) : row*photo.height/2;
        const cropHeight = index===4 ? (row===0?photo.height*600/1254:photo.height-cropTop) : photo.height/2;
        const scale = 572/Math.max(cellWidth,cropHeight), width=cellWidth*scale,height=cropHeight*scale;
        const ctx=this.context;
        ctx.fillStyle='#ffffff';ctx.fillRect(0,0,620,620);
        ctx.drawImage(photo,column*cellWidth,cropTop,cellWidth,cropHeight,(620-width)/2,(620-height)/2,width,height);
        const pixels=ctx.getImageData(0,0,620,620),data=pixels.data;
        const rgb=[1,3,5].map(i=>parseInt(s.hex.slice(i,i+2),16));
        for(let i=0;i<data.length;i+=4){
          const r=data[i],g=data[i+1],b=data[i+2];
          const mask=Math.min(1,Math.max(0,(g-Math.max(r,b)-10)/38));
          if(!mask)continue;
          const shade=Math.min(1.15,g/211);
          for(let j=0;j<3;j++)data[i+j]=data[i+j]*(1-mask)+Math.min(255,rgb[j]*shade)*mask;
        }
        ctx.putImageData(pixels,0,0);
      } catch { loading.textContent=this.config.error;loading.hidden=false; }
    }
  });
}

